query (
  $id: Int!
) {
  getPaymentStatus(
    id: $id
  )
}
